const locale = {
    placeholder: 'වේලාව තෝරන්න',
    rangePlaceholder: ['ආරම්භක වේලාව', 'නිමවන වේලාව'],
};
export default locale;
